//GREY
export const slate = '#333333';
export const ash = '#909090';
export const greyDark = '#a9a9a9';
export const grey = '#cccccc';
export const fog = '#e2e2e2';
export const greyLight = '#f1f1f1';
export const smoke = '#fbfbfb';
export const dust = '#f5f5f5';

//RED
export const red = '#ec3e4e';

//CORAL
export const maroon = '#6e2f25';
export const coralDark = '#c55543';
export const coral = '#f06751';
export const salmon = '#f59e90';
export const coralLight = '#fad5cf';
export const mistyRose = 'fdf1ef';

//PEACH
export const almond = '#9a6532';
export const peachDark = '#c68240';
export const peach = '#f19e4e';
export const melon = '#f6c18e';
export const peachLight = '#fbe4ce';
export const seashell = '#fdf6ee';

//YELLOW
export const cocoa = '#463613';
export const yellowDark = '#a37612';
export const yellow = '#ffb81c';
export const cantaloupe = '#ffd57d';
export const yellowLight = '#ffe8bb';
export const papayaWhip = '#fff4dd';

//NAVY
export const jet = '#02181e';
export const navyDark = '#033646';
export const navy = '#06556e';
export const cadetBlue = '#5f92a2';
export const navyLight = '#bad0d7';
export const cloud = '#e8eff1';

//TEAL
export const peacock = '#004b4f';
export const tealDark = '#00777e';
export const teal = '#00a3ad';
export const turquoise = '#5cc4ca';
export const tealLight = '#b9e5e8';
export const azure = '#e7f6f7';

//GREEN
export const green = '#1a8948';
export const greenLight = '#23d192';

//OUTLINE
export const outline = '#007aff';

const colors = {
    slate,
    ash,
    greyDark,
    grey,
    fog,
    greyLight,
    smoke,
    dust,
    red,
    maroon,
    coralDark,
    coral,
    coralLight,
    salmon,
    mistyRose,
    almond,
    peachDark,
    peach,
    melon,
    peachLight,
    seashell,
    cocoa,
    yellowDark,
    yellow,
    cantaloupe,
    yellowLight,
    papayaWhip,
    jet,
    navyDark,
    navy,
    cadetBlue,
    navyLight,
    cloud,
    peacock,
    tealDark,
    teal,
    turquoise,
    tealLight,
    azure,
    green,
    greenLight,
    outline,
};

export default colors;
